import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { LoginState} from './types';

export const actions: ActionTree<LoginState, RootState> = {
  authChange({ commit }): any {
    commit('onAuthStateChanged', true);
  }
};
